import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { flip, offset, useFloatingToolbar, useFloatingToolbarState } from '@udecode/plate-floating';
import { useComposedRef, useEditorId, createPlatePlugin, usePluginOption, useEventEditorValue } from '@udecode/plate/react';
import { forwardRef } from 'react';
import { theme } from '../theme';
import { useMarkdownProps } from './context';
import { LinkButton } from './LinkPlugin';
import { StyledFloatingToolbar } from './styled';
import { TextTypeSelect } from './TextTypeSelect';
import { BoldButton, CodeBlockButton, ItalicButton, UnderlineButton } from './ToolbarComponents';
import { PluginType } from './types';
const FloatingToolbar = /*#__PURE__*/ forwardRef(({ state }, componentRef)=>{
    const { supportedPluginTypes } = useMarkdownProps();
    const editorId = useEditorId();
    const focusedEditorId = useEventEditorValue('focus');
    const isFloatingLinkOpen = !!usePluginOption({
        key: 'a'
    }, 'mode');
    const floatingToolbarState = useFloatingToolbarState({
        editorId,
        focusedEditorId,
        hideToolbar: isFloatingLinkOpen,
        ...state,
        floatingOptions: {
            middleware: [
                offset(12),
                flip({
                    fallbackPlacements: [
                        'top-start',
                        'top-end',
                        'bottom-start',
                        'bottom-end'
                    ],
                    padding: 12
                })
            ],
            placement: 'top',
            ...state?.floatingOptions
        }
    });
    const { clickOutsideRef, hidden, props: rootProps, ref: floatingRef } = useFloatingToolbar(floatingToolbarState);
    const ref = useComposedRef(componentRef, floatingRef);
    if (hidden) return null;
    return /*#__PURE__*/ _jsx("div", {
        ref: clickOutsideRef,
        children: /*#__PURE__*/ _jsxs(StyledFloatingToolbar, {
            direction: "horizontal",
            gap: theme.spaces.x8,
            ref: ref,
            ...rootProps,
            alignY: "center",
            children: [
                supportedPluginTypes.has(PluginType.TextType) && /*#__PURE__*/ _jsx(TextTypeSelect, {}),
                supportedPluginTypes.has(PluginType.Bold) && /*#__PURE__*/ _jsx(BoldButton, {}),
                supportedPluginTypes.has(PluginType.Italic) && /*#__PURE__*/ _jsx(ItalicButton, {}),
                supportedPluginTypes.has(PluginType.Underline) && /*#__PURE__*/ _jsx(UnderlineButton, {}),
                supportedPluginTypes.has(PluginType.Link) && /*#__PURE__*/ _jsx(LinkButton, {}),
                supportedPluginTypes.has(PluginType.Code) && /*#__PURE__*/ _jsx(CodeBlockButton, {})
            ]
        })
    });
});
export const FloatingToolbarPlugin = createPlatePlugin({
    key: 'floating-toolbar',
    render: {
        afterEditable: ()=>/*#__PURE__*/ _jsx(FloatingToolbar, {})
    }
});
